import { t } from '@lingui/core/macro';
import { create } from 'zustand';
import useDataOutput from '../../hooks/UseDataOutput';

type LabelOutput = { id: number; url: string };
const useLabelOutputs = create<{ outputs: LabelOutput[] }>(() => ({ outputs: [] }));

export function monitorProductLabels(id: number, url: string) {
  useLabelOutputs.setState(({ outputs }) => ({
    outputs: outputs.some((output) => output.id === id) ? outputs : [...outputs, { id, url }]
  }));
}

function OutputMonitor({ id, url }: LabelOutput) {
  useDataOutput({ title: t`Printing product labels`, id, persistent: true, outputUrl: url });
  return null;
}

/** Keep native output monitoring mounted when the user changes pages. */
export function ProductLabelOutputs() {
  const outputs = useLabelOutputs((state) => state.outputs);
  return <>{outputs.map((output) => <OutputMonitor key={output.id} {...output} />)}</>;
}
